import { CurrentYear, getLoginUrl } from './InnerFunctions';
import { browserName, browserVersion } from 'react-device-detect';
import { useContext } from 'react';
import EnvironmentContext from './context/EnvironmentContext';
import { useSearchParams } from 'react-router-dom';
import { ErrorDetails, getErrorDetails } from './constants/errorCodes';

const ErrorPage = (props: { errorMsgScreen?: string; responseCode?: string }) => {
  const env = useContext(EnvironmentContext);

  let loginUrl: string = getLoginUrl(env);

  const [searchParams] = useSearchParams();
  const error = searchParams.get('error');

  const errorDetails: ErrorDetails = getErrorDetails(error);

  const responseCode = errorDetails.errorCode ? String(errorDetails.errorCode) : props.responseCode;
  const errorMsgScreen = errorDetails.errorMessage || props.errorMsgScreen;

  return (
    <div className="t-error-page">
      <div className="t-error-container">
        {responseCode === '200' || responseCode === '409' || responseCode === '400' || responseCode === '403' ? (
          <h1>Oops!!</h1>
        ) : (
          <h1>Something went wrong</h1>
        )}
        {errorMsgScreen === undefined || errorMsgScreen === null ? (
          <>
            <p>Due to server error we could not find the page you are looking for.</p>
            <p>
              The error is probably temporary, so please wait for a few seconds and then refresh page or try to re-login
              by clicking the below icon
            </p>
            <button className="t-btn t-primary" style={{ background: '#279c9c' }}>
              <a href={loginUrl} style={{ color: 'white', textDecoration: 'none' }}>
                Relogin
              </a>
            </button>
          </>
        ) : (
          <h3>{errorMsgScreen}</h3>
        )}
        <h2 style={{ lineHeight: '20px' }}>
          If you think you should be able to access this page, contact OSTTRA Support with error details like below:-
        </h2>
        <ul className="t-list">
          <li>
            Find OSTTRA Support contacts here - <a href="https://osttra.com/support/">www.osttra.com/support</a>
          </li>
        </ul>
        <></>
        <h2>Status :- </h2>
        <dl className="t-error-container__meta-data" aria-label="meta-data">
          <dt>Response code </dt>
          <dd>{responseCode}</dd>
          <dt>Time </dt>
          <dd>{new Date().toUTCString()}</dd>
          <dt>URL</dt>
          <dd>{loginUrl}</dd>
          <dt>Browser information</dt>
          <dd>{browserName + ' ' + browserVersion}</dd>
        </dl>

        <footer style={{ marginTop: '25px', minHeight: '2.375rem' }}>
          © {CurrentYear} OSTTRA Group. Proprietary and Confidential.{' '}
          <a href="https://osttra.com/disclaimer/" target="_disclaimer">
            Disclaimer.
          </a>
        </footer>
      </div>
    </div>
  );
};

export default ErrorPage;
